import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import colors, { shadows } from '../theme';
import { trackLogin } from '../utils/analytics';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

function LoginPage() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            const loginData = { email, password };

            const response = await axios.post(`${API_URL}/auth/login`, loginData);

            if (response.data.success) {
                // Store token and user info
                localStorage.setItem('token', response.data.data.token);
                localStorage.setItem('user', JSON.stringify(response.data.data.user));
                localStorage.setItem('organization', JSON.stringify(response.data.data.organization));

                // Track login event
                trackLogin(response.data.data.user.id);

                // Redirect to dashboard
                navigate('/dashboard');
            }
        } catch (err) {
            setError(err.response?.data?.error || 'Login failed. Please check your credentials.');
            setLoading(false);
        }
    };

    return (
        <div style={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: colors.gray[100]
        }}>
            <div style={{
                backgroundColor: colors.white,
                padding: '2.5rem',
                borderRadius: '12px',
                boxShadow: shadows.md,
                width: '100%',
                maxWidth: '450px'
            }}>
                <h1 style={{ 
                    marginBottom: '0.5rem', 
                    textAlign: 'center',
                    fontSize: '2rem',
                    fontWeight: 'bold'
                }}>
                    Welcome Back
                </h1>
                <p style={{ 
                    textAlign: 'center', 
                    color: colors.gray[600], 
                    marginBottom: '2rem',
                    fontSize: '0.95rem'
                }}>
                    Sign in to your organization
                </p>

                <form onSubmit={handleLogin}>
                    <div style={{ marginBottom: '1rem' }}>
                        <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500' }}>
                            Email
                        </label>
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            placeholder="your@email.com"
                            style={{
                                width: '100%',
                                padding: '0.75rem',
                                border: `1px solid ${colors.gray[300]}`,
                                borderRadius: '6px',
                                fontSize: '1rem'
                            }}
                        />
                    </div>

                    <div style={{ marginBottom: '1.5rem' }}>
                        <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500' }}>
                            Password
                        </label>
                        <input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            minLength="6"
                            placeholder="••••••••"
                            style={{
                                width: '100%',
                                padding: '0.75rem',
                                border: `1px solid ${colors.gray[300]}`,
                                borderRadius: '6px',
                                fontSize: '1rem'
                            }}
                        />
                    </div>

                    {error && (
                        <div style={{
                            padding: '0.75rem',
                            backgroundColor: colors.red[50],
                            color: colors.red[600],
                            borderRadius: '6px',
                            marginBottom: '1rem',
                            fontSize: '0.875rem'
                        }}>
                            {error}
                        </div>
                    )}

                    <button
                        type="submit"
                        disabled={loading}
                        style={{
                            width: '100%',
                            padding: '0.875rem',
                            backgroundColor: loading ? colors.gray[400] : colors.blue[500],
                            color: colors.white,
                            border: 'none',
                            borderRadius: '8px',
                            fontSize: '1.1rem',
                            fontWeight: '600',
                            cursor: loading ? 'not-allowed' : 'pointer',
                            transition: 'background-color 0.2s'
                        }}
                        onMouseOver={(e) => {
                            if (!loading) e.target.style.backgroundColor = colors.blue[600];
                        }}
                        onMouseOut={(e) => {
                            if (!loading) e.target.style.backgroundColor = colors.blue[500];
                        }}
                    >
                        {loading ? 'Signing in...' : 'Sign In'}
                    </button>
                </form>

                <div style={{ 
                    marginTop: '1.5rem', 
                    paddingTop: '1.5rem', 
                    borderTop: `1px solid ${colors.gray[200]}`,
                    textAlign: 'center' 
                }}>
                    <p style={{ fontSize: '0.875rem', color: '#6b7280', marginBottom: '0.5rem' }}>
                        Don't have an organization?
                    </p>
                    <button
                        onClick={() => navigate('/register')}
                        style={{
                            color: colors.blue[500],
                            background: 'none',
                            border: 'none',
                            cursor: 'pointer',
                            fontSize: '1rem',
                            fontWeight: '600',
                            textDecoration: 'underline'
                        }}
                    >
                        Create Your Organization
                    </button>
                </div>
            </div>
        </div>
    );
}

export default LoginPage;